/**
 * Order confirmation — collapse extra line items.
 */

export function initThankyouItems() {
	const root = document.querySelector('[data-thankyou-items]');
	if (!root) {
		return;
	}

	const extras = root.querySelectorAll('[data-thankyou-extra]');
	const toggle = root.querySelector('[data-thankyou-more]');
	const label = toggle?.querySelector('[data-thankyou-more-label]');

	if (!extras.length || !(toggle instanceof HTMLButtonElement) || !label) {
		return;
	}

	root.classList.add('is-collapsible-ready');
	toggle.hidden = false;

	const setExpanded = (expanded) => {
		root.classList.toggle('is-expanded', expanded);
		toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		label.textContent = expanded
			? toggle.dataset.labelLess || 'Show fewer'
			: toggle.dataset.labelMore || '+ more items';
	};

	setExpanded(false);

	toggle.addEventListener('click', () => {
		setExpanded(!root.classList.contains('is-expanded'));
	});
}
